import { render, staticRenderFns } from "./ItemForTable.vue?vue&type=template&id=bbb21dcc&scoped=true"
import script from "./ItemForTable.vue?vue&type=script&lang=ts"
export * from "./ItemForTable.vue?vue&type=script&lang=ts"
import style0 from "./ItemForTable.vue?vue&type=style&index=0&id=bbb21dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb21dcc",
  null
  
)

export default component.exports